import React, { useEffect } from 'react';
import LegalLayout from './LegalLayout';

const summaryLinks = [
  {
    "href": "#escopo",
    "label": "Escopo"
  },
  {
    "href": "#definicoes",
    "label": "Definições"
  },
  {
    "href": "#categorias",
    "label": "Categorias"
  },
  {
    "href": "#tabela",
    "label": "Tabela resumida"
  },
  {
    "href": "#finalidades",
    "label": "Finalidades"
  },
  {
    "href": "#terceiros",
    "label": "Terceiros"
  },
  {
    "href": "#consentimento",
    "label": "Consentimento"
  },
  {
    "href": "#retencao",
    "label": "Retenção"
  },
  {
    "href": "#dados",
    "label": "Dados pessoais"
  },
  {
    "href": "#gerenciamento",
    "label": "Gerenciamento"
  },
  {
    "href": "#seguranca",
    "label": "Segurança"
  },
  {
    "href": "#alteracoes",
    "label": "Alterações"
  },
  {
    "href": "#contato",
    "label": "Contato"
  }
];

const cookieRows = [
  {
    categoria: 'Necessários',
    finalidade: 'Login, sessão, segurança, checkout e funcionamento do painel.',
    exemplos: 'Token de sessão, CSRF, autenticação, carrinho/checkout e preferência essencial.',
    gestao: 'Necessários para execução do serviço e segurança. Não exigem consentimento.'
  },
  {
    categoria: 'Preferências',
    finalidade: 'Memorizar escolhas de interface e configurações do usuário.',
    exemplos: 'Tema claro/escuro, unidade selecionada, filtros, menus e idioma.',
    gestao: 'Podem ser gerenciados pela Central de Preferências ou pelo navegador.'
  },
  {
    categoria: 'Analíticos',
    finalidade: 'Medir desempenho, erros, navegação e uso agregado.',
    exemplos: 'Eventos de página, métricas de performance, origem de acesso e falhas.',
    gestao: 'Dependem da configuração e podem exigir consentimento.'
  },
  {
    categoria: 'Marketing',
    finalidade: 'Medir campanhas, anúncios, conversões e remarketing.',
    exemplos: 'Pixels, tags de anúncios, origem de campanha e conversões.',
    gestao: 'Dependem de consentimento, salvo hipótese legal aplicável.'
  },
  {
    categoria: 'Terceiros',
    finalidade: 'Viabilizar pagamentos, hospedagem, suporte e integrações.',
    exemplos: 'Mercado Pago, infraestrutura, analytics, suporte e mensageria.',
    gestao: 'Podem seguir políticas próprias dos provedores.'
  }
];

function PrintButton() {
  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="lumix-print-button"
      aria-label="Imprimir ou salvar esta Política de Cookies em PDF"
    >
      Imprimir / salvar PDF
    </button>
  );
}

function LegalNote({ children, variant = 'default' }) {
  return <div className={`lumix-cookie-note lumix-cookie-note--${variant}`}>{children}</div>;
}

export default function PoliticaCookies() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalLayout
      eyebrow="Privacidade e Navegação"
      title="Política de Cookies"
      description="Esta política explica como a Lumix Óticas utiliza cookies e tecnologias semelhantes para garantir funcionamento, segurança, checkout, autenticação e uma experiência transparente no uso da plataforma."
      summaryLinks={summaryLinks}
    >
      <style>{`
        .lumix-print-button {
          appearance: none;
          min-height: 40px;
          padding: 0 14px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin: 0 0 30px;
          border: 1px solid #d5dde8;
          border-radius: 11px;
          background: #ffffff;
          color: #343943;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 11px;
          font-weight: 750;
          cursor: pointer;
          box-shadow: 0 1px 2px rgba(15,23,42,.04);
          transition: background .16s ease, border-color .16s ease, transform .16s ease;
        }

        .lumix-print-button:hover {
          background: #f8fafc;
          border-color: #c8d2df;
          transform: translateY(-1px);
        }

        .legal-article > section {
          scroll-margin-top: 96px;
        }

        .legal-article > section > h2 {
          position: relative;
          margin: 42px 0 15px;
          padding-bottom: 13px;
          border-bottom: 1px solid #e6ebf1;
          color: #171a21;
          font-family: 'Nunito', 'Inter', system-ui, sans-serif;
          font-size: 1.22rem;
          line-height: 1.35;
          font-weight: 900;
          letter-spacing: -.025em;
        }

        .legal-article > section > h2::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -1px;
          width: 42px;
          height: 2px;
          border-radius: 999px;
          background: #1a73e8;
        }

        .legal-article > section:first-of-type > h2 {
          margin-top: 0;
        }

        .legal-article > section > h3 {
          margin: 28px 0 10px;
          color: #20242c;
          font-family: 'Nunito', 'Inter', system-ui, sans-serif;
          font-size: .98rem;
          line-height: 1.4;
          font-weight: 850;
          letter-spacing: -.015em;
        }

        .legal-article > section > p,
        .legal-article > section > ul li {
          color: #46505f;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: .92rem;
          line-height: 1.8;
          font-weight: 450;
        }

        .legal-article > section > p {
          margin: 0 0 15px;
        }

        .legal-article > section > ul {
          margin: 8px 0 22px;
          padding-left: 1.3rem;
        }

        .legal-article > section > ul li {
          margin: 0 0 8px;
          padding-left: 3px;
        }

        .legal-article > section > ul li::marker {
          color: #1a73e8;
        }

        .legal-article > section > ul li strong {
          color: #20242c;
          font-weight: 800;
        }

        .lumix-cookie-note {
          position: relative;
          margin: 18px 0;
          padding: 14px 15px 14px 18px;
          border: 1px solid #e3e8ef;
          border-radius: 13px;
          background: #fafcfe;
          color: #626a78;
          font-family: 'Inter', system-ui, sans-serif;
          font-size: 11px;
          line-height: 1.65;
          font-weight: 500;
        }

        .lumix-cookie-note::before {
          content: '';
          position: absolute;
          left: 0;
          top: 12px;
          bottom: 12px;
          width: 3px;
          border-radius: 0 999px 999px 0;
          background: #1a73e8;
        }

        .lumix-cookie-note--blue {
          border-color: #d7e5fa;
          background: #f6f9fe;
          color: #3d5f8d;
        }

        .lumix-cookie-note--warning {
          border-color: #f1dfae;
          background: #fffaf0;
          color: #765b18;
        }

        .lumix-cookie-note--warning::before {
          background: #fbbc04;
        }

        .lumix-cookie-note strong {
          font-weight: 800;
          color: #343943;
        }

        .lumix-cookie-table-wrap {
          overflow-x: auto;
          margin: 20px 0 10px;
          border: 1px solid #e3e8ef;
          border-radius: 15px;
          background: #ffffff;
          box-shadow: 0 1px 2px rgba(15,23,42,.025);
        }

        .lumix-cookie-table {
          width: 100%;
          min-width: 820px;
          border-collapse: collapse;
        }

        .lumix-cookie-table th,
        .lumix-cookie-table td {
          padding: 13px 14px;
          text-align: left;
          vertical-align: top;
          border-bottom: 1px solid #edf0f4;
          font-family: 'Inter', system-ui, sans-serif;
        }

        .lumix-cookie-table th {
          background: #f8fafc;
          color: #626a78;
          font-size: 9px;
          line-height: 1.3;
          font-weight: 800;
          letter-spacing: .07em;
          text-transform: uppercase;
        }

        .lumix-cookie-table td {
          color: #46505f;
          font-size: 11px;
          line-height: 1.65;
          font-weight: 450;
        }

        .lumix-cookie-table td:first-child {
          color: #20242c;
          font-weight: 800;
          white-space: nowrap;
        }

        .lumix-cookie-table tr:last-child td {
          border-bottom: 0;
        }

        @media (max-width: 720px) {
          .lumix-print-button {
            width: 100%;
            margin-bottom: 24px;
          }

          .legal-article > section > h2 {
            margin-top: 34px;
            font-size: 1.06rem;
          }

          .legal-article > section > h3 {
            font-size: .93rem;
          }

          .legal-article > section > p,
          .legal-article > section > ul li {
            font-size: .86rem;
            line-height: 1.75;
          }

          .legal-article > section > ul {
            padding-left: 1.15rem;
          }

          .lumix-cookie-note {
            padding: 13px 14px 13px 17px;
            font-size: 10px;
          }

          .lumix-cookie-table-wrap {
            margin-left: -4px;
            margin-right: -4px;
            border-radius: 12px;
          }
        }

        @media print {
          .lumix-print-button {
            display: none !important;
          }

          .lumix-cookie-note,
          .lumix-cookie-table-wrap {
            break-inside: avoid;
          }

          .lumix-cookie-table-wrap {
            overflow: visible;
          }
        }
      `}</style>

      <PrintButton />

      <section id="escopo">
        <h2>1. Escopo desta Política</h2>
        <p>
          Esta Política de Cookies explica como a Lumix Óticas utiliza cookies, pixels, identificadores,
          armazenamento local do navegador, tecnologias semelhantes e ferramentas de terceiros no site institucional,
          checkout, painel administrativo, páginas legais, área de login, recursos de suporte e demais ambientes digitais
          relacionados à plataforma.
        </p>
        <p>
          Esta política deve ser lida em conjunto com os Termos de Uso, a Política de Privacidade e as Condições
          Comerciais da Lumix Óticas. Em caso de conflito entre documentos, prevalecerá a regra mais específica para o
          tema tratado, sem prejuízo da aplicação da legislação vigente.
        </p>
        <p>
          A Lumix Óticas é uma plataforma SaaS B2B voltada à gestão de óticas. Por isso, determinados cookies são
          necessários para autenticação, segurança, sessão, checkout, prevenção de fraude e funcionamento do painel
          contratado pela empresa usuária.
        </p>
      </section>

      <section id="definicoes">
        <h2>2. O que são cookies e tecnologias semelhantes</h2>
        <p>
          Cookies são pequenos arquivos ou identificadores armazenados no navegador ou dispositivo do usuário durante o
          acesso a um site ou sistema. Eles permitem reconhecer uma sessão, manter preferências, reforçar segurança,
          lembrar configurações, medir desempenho e viabilizar funcionalidades essenciais.
        </p>
        <p>
          Tecnologias semelhantes incluem pixels, tags, web beacons, SDKs, armazenamento local, session storage,
          identificadores de dispositivo e registros técnicos de navegação. Nesta política, a palavra “cookies” também
          abrange essas tecnologias, quando aplicável.
        </p>
        <p>
          Alguns cookies são definidos diretamente pela Lumix Óticas. Outros podem ser definidos por terceiros
          contratados para atividades necessárias, como processamento de pagamento, infraestrutura, prevenção de fraude,
          suporte, analytics, mensageria ou integrações autorizadas.
        </p>
      </section>

      <section id="categorias">
        <h2>3. Categorias de cookies utilizados</h2>
        <p>
          A Lumix Óticas poderá utilizar as categorias abaixo, conforme o ambiente acessado, o plano contratado, as
          integrações habilitadas e as preferências de privacidade do usuário.
        </p>

        <h3>3.1. Cookies estritamente necessários</h3>
        <p>
          São indispensáveis para a operação da plataforma. Viabilizam login, autenticação, sessão segura, proteção contra
          uso indevido, prevenção de fraude, roteamento de requisições, checkout, gravação de preferências essenciais e
          cumprimento de obrigações técnicas de segurança.
        </p>
        <p>
          Esses cookies não dependem de consentimento prévio, pois são necessários para entregar o serviço solicitado e
          manter a segurança da plataforma. O bloqueio desses cookies pode impedir login, pagamento, navegação no painel
          ou uso correto das funcionalidades contratadas.
        </p>

        <h3>3.2. Cookies de preferência e funcionalidade</h3>
        <p>
          Permitem lembrar escolhas feitas pelo usuário, como unidade selecionada, idioma, aparência da interface, estado
          de menus, filtros recentes, configurações de visualização, preferências de formulário e outras opções que
          melhoram a experiência no painel.
        </p>

        <h3>3.3. Cookies analíticos e de desempenho</h3>
        <p>
          Ajudam a compreender uso, estabilidade, páginas acessadas, erros, tempo de carregamento, origem de tráfego,
          comportamento agregado e pontos de melhoria do site ou sistema. Sempre que utilizados para fins não
          estritamente necessários, esses cookies poderão depender de consentimento.
        </p>

        <h3>3.4. Cookies de marketing, mídia e remarketing</h3>
        <p>
          Podem ser usados para medir campanhas, entender conversões, avaliar anúncios, integrar ferramentas de suporte ou
          mensageria e criar públicos de remarketing, quando a Lumix utilizar ferramentas como pixels, tags de anúncios ou
          plataformas de mídia.
        </p>
        <p>
          Esses cookies não são essenciais para o uso da plataforma e devem ser ativados apenas mediante consentimento ou
          outra base legal aplicável. O usuário poderá recusar ou retirar o consentimento sem prejuízo do acesso às
          funcionalidades essenciais.
        </p>

        <h3>3.5. Cookies de segurança, antifraude e auditoria</h3>
        <p>
          Podem ser utilizados para detectar tentativas de acesso indevido, proteger sessões, reduzir risco de fraudes,
          validar tokens, registrar eventos técnicos, identificar comportamentos anômalos e preservar evidências
          operacionais relacionadas à segurança da conta.
        </p>
      </section>

      <section id="tabela">
        <h2>4. Tabela resumida de cookies</h2>
        <p>
          A tabela abaixo resume as principais categorias de cookies que podem ser utilizadas. Os nomes técnicos
          específicos podem variar conforme o provedor, ambiente, versão da plataforma, navegador, integrações contratadas
          e ferramentas habilitadas.
        </p>

        <div className="lumix-cookie-table-wrap">
          <table className="lumix-cookie-table">
            <thead>
              <tr>
                <th>Categoria</th>
                <th>Finalidade</th>
                <th>Exemplos de uso</th>
                <th>Base / gestão</th>
              </tr>
            </thead>
            <tbody>
              {cookieRows.map((row) => (
                <tr key={row.categoria}>
                  <td>{row.categoria}</td>
                  <td>{row.finalidade}</td>
                  <td>{row.exemplos}</td>
                  <td>{row.gestao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section id="finalidades">
        <h2>5. Finalidades do uso de cookies</h2>
        <p>A Lumix Óticas poderá utilizar cookies e tecnologias semelhantes para as seguintes finalidades:</p>
        <ul>
          <li>Manter o usuário autenticado com segurança durante a sessão.</li>
          <li>Proteger contas, prevenir fraude, abuso, spam, acessos indevidos e violações de segurança.</li>
          <li>Viabilizar o checkout, pagamentos, confirmação de contratação e emissão de comprovantes operacionais.</li>
          <li>Preservar preferências de navegação, unidade, filtros, menus, aparência e configurações da interface.</li>
          <li>Medir desempenho, estabilidade, erros, disponibilidade, usabilidade e melhorias da plataforma.</li>
          <li>Avaliar campanhas de divulgação, conversões e origem de tráfego, quando ferramentas de marketing estiverem habilitadas.</li>
          <li>Cumprir obrigações legais, regulatórias, contratuais e de segurança da informação.</li>
          <li>Gerar registros técnicos de auditoria, suporte e prevenção de uso indevido.</li>
        </ul>
      </section>

      <section id="terceiros">
        <h2>6. Cookies e tecnologias de terceiros</h2>
        <p>
          A Lumix Óticas poderá utilizar serviços de terceiros para viabilizar funcionalidades técnicas e comerciais. Esses
          terceiros podem definir cookies ou tecnologias próprias, conforme suas respectivas políticas de privacidade e cookies.
        </p>
        <ul>
          <li>Mercado Pago ou outro gateway de pagamento para checkout, assinatura, antifraude e processamento financeiro.</li>
          <li>Serviços de hospedagem, VPS, cloud, CDN, banco de dados, logs e monitoramento de disponibilidade.</li>
          <li>Ferramentas de analytics e performance, quando habilitadas.</li>
          <li>Ferramentas de suporte, chat, comunicação, WhatsApp ou mensageria, quando integradas.</li>
          <li>Plataformas de publicidade, pixel ou mensuração de campanhas, quando expressamente utilizadas.</li>
        </ul>
      </section>

      <section id="consentimento">
        <h2>7. Consentimento e Central de Preferências</h2>
        <p>
          A Lumix Óticas poderá disponibilizar banner ou Central de Preferências para que o usuário aceite, recuse ou
          personalize cookies não essenciais. A recusa de cookies analíticos ou de marketing não impede o uso das
          funcionalidades essenciais da plataforma.
        </p>
        <p>
          O usuário poderá alterar suas preferências a qualquer momento, quando a Central de Preferências estiver
          disponível, ou poderá configurar o bloqueio diretamente nas opções do navegador.
        </p>
      </section>

      <section id="retencao">
        <h2>8. Prazo de retenção dos cookies</h2>
        <p>
          Os cookies podem ser de sessão ou persistentes. Cookies de sessão são apagados ao fechar o navegador ou encerrar
          a sessão. Cookies persistentes permanecem por prazo definido para manter preferências, segurança, analytics,
          antifraude ou registros técnicos necessários.
        </p>
        <p>
          Os prazos de retenção podem variar conforme a categoria, finalidade e provedor. A Lumix Óticas buscará manter
          cookies pelo menor período razoável para cumprir suas finalidades, respeitando obrigações legais, contratuais,
          de segurança, auditoria e defesa de direitos.
        </p>
      </section>

      <section id="dados">
        <h2>9. Dados pessoais relacionados aos cookies</h2>
        <p>
          Cookies podem envolver o tratamento de dados pessoais ou dados técnicos associados a uma pessoa identificada ou
          identificável, como endereço IP, identificadores de sessão, registros de login, informações do navegador,
          dispositivo, data e hora de acesso, páginas acessadas e eventos de uso.
        </p>
        <p>
          Quando esses dados forem tratados pela Lumix para fins próprios, como segurança do site, atendimento, cobrança,
          suporte, melhoria da plataforma e comunicação institucional, a Lumix poderá atuar como controladora. Quando o
          tratamento ocorrer no contexto da operação da plataforma para a empresa contratante e seus usuários autorizados,
          a Lumix poderá atuar como operadora, conforme a Política de Privacidade e os Termos de Uso.
        </p>
        <p>
          A Lumix não utiliza cookies para vender dados pessoais. Eventuais dados coletados por cookies são tratados
          conforme finalidades legítimas, contratuais, legais ou consentidas, observada a legislação aplicável.
        </p>
      </section>

      <section id="gerenciamento">
        <h2>10. Como gerenciar ou bloquear cookies</h2>
        <p>
          Além da Central de Preferências da Lumix, quando disponível, o usuário pode bloquear, excluir ou configurar
          cookies diretamente no navegador. Cada navegador possui seus próprios menus de privacidade e segurança.
        </p>
        <LegalNote variant="warning">
          <strong>Importante:</strong> bloquear cookies necessários pode impedir login, checkout, autenticação, permanência
          de sessão, painel administrativo, preferências, integrações e recursos de segurança.
        </LegalNote>
        <p>
          Em dispositivos compartilhados, recomenda-se encerrar a sessão após o uso, evitar salvar senhas em computadores
          de terceiros e limpar cookies quando necessário.
        </p>
      </section>

      <section id="seguranca">
        <h2>11. Segurança e registros técnicos</h2>
        <p>
          A Lumix Óticas poderá manter registros técnicos de acesso, autenticação, sessão, falhas, tentativas de login,
          eventos de segurança, alterações críticas e uso de funcionalidades, com o objetivo de proteger a plataforma,
          cumprir obrigações legais e preservar evidências em caso de uso indevido.
        </p>
        <p>
          Esses registros podem ser tratados com base na execução do contrato, cumprimento de obrigação legal, legítimo
          interesse, prevenção de fraude, segurança da informação e exercício regular de direitos.
        </p>
      </section>

      <section id="alteracoes">
        <h2>12. Alterações desta Política</h2>
        <p>
          Esta Política de Cookies poderá ser atualizada para refletir mudanças legais, regulatórias, técnicas, comerciais,
          operacionais ou de fornecedores. A versão vigente será disponibilizada no site ou painel da Lumix Óticas.
        </p>
        <p>
          Alterações relevantes poderão ser comunicadas por aviso no painel, e-mail, banner, página legal ou outro meio
          razoável. O uso contínuo da plataforma após a publicação da nova versão indica ciência das alterações, sem
          prejuízo do direito de ajustar preferências quando aplicável.
        </p>
      </section>

      <section id="contato">
        <h2>13. Contato sobre privacidade e cookies</h2>
        <p>
          Dúvidas, solicitações ou reclamações relacionadas a cookies, privacidade e proteção de dados podem ser encaminhadas
          pelos canais oficiais da Lumix Óticas.
        </p>
        <ul>
          <li><strong>Controladora/Fornecedor da plataforma:</strong> [INSERIR RAZÃO SOCIAL DA EMPRESA RESPONSÁVEL PELA LUMIX ÓTICAS].</li>
          <li><strong>CNPJ:</strong> [INSERIR CNPJ].</li>
          <li><strong>Endereço:</strong> [INSERIR ENDEREÇO COMPLETO].</li>
          <li><strong>E-mail de privacidade/DPO:</strong> [INSERIR E-MAIL DE PRIVACIDADE].</li>
          <li><strong>E-mail de suporte:</strong> [INSERIR E-MAIL DE SUPORTE].</li>
          <li><strong>WhatsApp oficial:</strong> [INSERIR WHATSAPP OFICIAL].</li>
          <li><strong>Data da última atualização:</strong> 28 de maio de 2026.</li>
        </ul>

      </section>
    </LegalLayout>
  );
}
